// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import OverflowMenuPresentationPropsDefault from "@insite/mobius/OverflowMenu/presentationProps";
import { xBaseTheme } from "@steiner/XDL/types";
import { color, styledScrollbar } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...OverflowMenuPresentationPropsDefault,
        mergeCss: true,
        buttonProps: {
            color: "common.background",
            shape: "pill",
            buttonType: "solid",
            shadow: false,
            css: css`
                &[data-test-selector="popoverOverflowTrigger"] {
                    width: 34px;
                    height: 34px;
                    border-radius: 50%;
                }

                & > ${IconWrapper} {
                    top: 0;
                }
                &:hover > ${IconWrapper}, &:focus > ${IconWrapper} {
                    color: ${color("common.white")};
                }
            `,
        },
        cssOverrides: {
            wrapper: css`
                display: flex;
                align-items: center;
                &[data-has-children="false"] {
                    display: none;
                }
            `,
            menu: css`
                overflow-y: auto;
                ${styledScrollbar(4)}
            `,
        },
    },
} as xBaseTheme["overflowMenu"];
